"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- DATEPICKER : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'DatePicker',
  props: {
    type: {
      type: 'string',
      default: 'day'
    },
    selectedDay: {
      type: 'string',
      default: '01-01-1992'
    },
    handleRangeSelect: {
      type: 'function',
      default: function _default() {
        return console.log('Selected Range');
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    disabledDays: {
      type: 'object',
      default: [{
        after: new Date(1000 * 60 * 60 * 24)
      }]
    },
    numberOfMonths: {
      type: 'number',
      default: 1
    }
  }
};
exports.default = _default2;